import { useState, useEffect } from "react";
import { fetchSubtopics } from "../services/fetchSubtopics";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchSubtopics() {
  const [subtopics, setSubtopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const { auth, setCommonWarning, breadcrumbs } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // console.log("useFetchSubtopics called");

    const loadSubTopics = async () => {
      try {
        // console.log("breadcrumbs", breadcrumbs);
        // const topic = 1;
        const topic =
          breadcrumbs.find((item) => item.path === "/subtopics")?.id || null;
        // console.log("topic", topic);
        const data = await fetchSubtopics(auth.token, topic);
        // setSubtopics(data);
        if (data.status === 200) {
          // const fnldata = data.data.map((subtopic) => ({
          //   id: subtopic.id,
          //   name: subtopic.title,
          //   image: `${process.env.REACT_APP_PUBLIC_API_URL}${subtopic.thumbnail}`,
          //   category: subtopic.category,
          //   is_completed: subtopic.is_completed,
          // }));

          const defaultObj = {
            id: 0,
            name: "Completed",
            image: "",
            category: "",
            is_completed: 0,
          };

          const fnldata = [
            ...data.data.map((subtopic) => ({
              id: subtopic.id,
              name: subtopic.title,
              image: `${process.env.REACT_APP_PUBLIC_API_URL}${subtopic.thumbnail}`,
              category: subtopic.category,
              is_completed: subtopic.is_completed,
            })),
            defaultObj,
          ];

          // console.log("fnldata", fnldata)

          setSubtopics(fnldata);
        } else if (data.status === 400) {
          setCommonWarning(data.message);
        } else if (data.status === 401) {
          navigate("/login");
          return []; // return empty if unauthorized
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    loadSubTopics();
  }, [auth, breadcrumbs, setCommonWarning]);

  return [subtopics, loading];
}

export default useFetchSubtopics;
